module.exports = __webpack_public_path__ + "static/media/checkbox.5ecb567e.svg";